module.exports = __webpack_public_path__ + "static/media/16UNODC13.1324c742.jpg";